import script from "./ColumnHider.vue?vue&type=script&setup=true&lang=js"
export * from "./ColumnHider.vue?vue&type=script&setup=true&lang=js"

import "./ColumnHider.vue?vue&type=style&index=0&id=f60e3dd2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f60e3dd2"]])

export default __exports__